/**
 * Bundle Single Unit (kolczyki „Jeden”)
 * Osobny system — nie współdzieli stanu z klasycznym bundle-widget-t4e.
 */
(function () {
  if (window.__BundleSingleUnitBound) return;
  window.__BundleSingleUnitBound = true;

  const W = document.getElementById('bundle-widget-single-t4e');
  if (!W) return;

  const CONFIG = {
    currency: 'PLN',
    storageKeyBase: 'bundleSelection-single-unit-v1',
    fixedPrice: 0,
    discountCode: null,
    limits: { x: 0, y: 0 },
    handles: { x: '', y: '' },
    titles: { x: 'Kolekcja X', y: 'Kolekcja Y' },
    clearCartBeforeCheckout: false,
    stickyHeaderOffset: 64,
    sameCollection: false,
  };

  const MINT_ENDPOINT = (
    window.ICS_MINT_ENDPOINT ||
    'https://iced-stuff-bundle-codes.krystian-smidowicz.workers.dev'
  ).replace(/\/+$/, '');

  try {
    CONFIG.currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || CONFIG.currency;
  } catch (e) {}

  CONFIG.limits.x = +W.dataset.xCount || 0;
  CONFIG.limits.y = +W.dataset.yCount || 0;
  CONFIG.handles.x = (W.dataset.xCollectionHandle || '').trim();
  CONFIG.handles.y = (W.dataset.yCollectionHandle || '').trim();
  CONFIG.titles.x = (W.dataset.xCollectionTitle || 'Kolekcja X').trim();
  CONFIG.titles.y = (W.dataset.yCollectionTitle || 'Kolekcja Y').trim();
  CONFIG.discountCode = (W.dataset.discountCode || '').trim();
  CONFIG.fixedPrice = +W.dataset.fixedPrice || 0;
  CONFIG.sameCollection = !!(CONFIG.handles.x && CONFIG.handles.x === CONFIG.handles.y);

  const enabled =
    CONFIG.limits.x > 0 &&
    CONFIG.limits.y > 0 &&
    CONFIG.handles.x &&
    CONFIG.handles.y &&
    CONFIG.fixedPrice > 0;

  if (!enabled) {
    W.classList.add('is-disabled');
    return;
  }

  W.classList.remove('hidden-t4e');

  const storageKey = () =>
    `${CONFIG.storageKeyBase}::${CONFIG.handles.x || 'no-x'}__${CONFIG.handles.y || 'no-y'}`;

  const $bar = W.querySelector('.js-bsu-bar');
  const $title = W.querySelector('.js-bsu-title');
  const $total = W.querySelector('.js-bsu-total');
  const $save = W.querySelector('.js-bsu-save');
  const $cta = W.querySelector('#bundle-cta-single-t4e');
  const $badge = W.querySelector('.js-bsu-count');
  const $avatars = W.querySelector('.js-bsu-avatars');

  let sel = loadSelection();
  let checkoutBusy = false;
  let $gridParent = null;

  function needTotal() {
    return CONFIG.limits.x + CONFIG.limits.y;
  }
  function countSelected() {
    return sel.x.length + sel.y.length;
  }
  function isComplete() {
    if (CONFIG.sameCollection) return countSelected() >= needTotal();
    return sel.x.length >= CONFIG.limits.x && sel.y.length >= CONFIG.limits.y;
  }
  function fmtMoney(n) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: CONFIG.currency,
    }).format(+n || 0);
  }
  function fmtPercent(n) {
    return new Intl.NumberFormat(undefined, {
      style: 'percent',
      maximumFractionDigits: 0,
    }).format(n);
  }
  function loadSelection() {
    try {
      const raw = sessionStorage.getItem(storageKey());
      const val = raw ? JSON.parse(raw) : null;
      return {
        x: Array.isArray(val && val.x) ? val.x : [],
        y: Array.isArray(val && val.y) ? val.y : [],
      };
    } catch (e) {
      return { x: [], y: [] };
    }
  }
  function saveSelection(v) {
    try {
      sessionStorage.setItem(storageKey(), JSON.stringify(v || sel));
    } catch (e) {}
  }
  function findCard(el) {
    return el && el.closest ? el.closest('[data-b-in]') : null;
  }
  function getGridParent() {
    if ($gridParent && document.body.contains($gridParent)) return $gridParent;
    const firstCard = document.querySelector('[data-bsu-card]');
    $gridParent = firstCard ? firstCard.parentElement : null;
    return $gridParent;
  }
  function cardForVariant(id) {
    const btn = document.querySelector(
      `.js-bsu-toggle[data-variant-id="${CSS.escape(String(id))}"]`
    );
    return btn ? findCard(btn) : null;
  }
  function setBtnState(btn, selected) {
    if (!btn) return;
    const label = btn.querySelector('.js-bsu-label');
    btn.classList.toggle('is-remove', !!selected);
    if (label) label.textContent = selected ? 'Usuń' : 'Dodaj';
    const card = findCard(btn);
    if (card) card.classList.toggle('is-selected', !!selected);
  }
  function syncButtons() {
    document.querySelectorAll('.js-bsu-toggle').forEach(function (btn) {
      const id = String(btn.dataset.variantId || '');
      const selected =
        sel.x.some(function (p) {
          return p.id === id;
        }) ||
        sel.y.some(function (p) {
          return p.id === id;
        });
      setBtnState(btn, selected);
    });
  }
  function render() {
    const count = countSelected();
    const need = needTotal();
    const progress = Math.min(100, Math.round((count / Math.max(need, 1)) * 100));
    if ($bar) $bar.style.width = progress + '%';
    if ($badge) $badge.textContent = count + '/' + need;

    const remaining = Math.max(0, need - count);
    if ($title) {
      if (isComplete()) {
        $title.textContent = 'Zestaw gotowy 2 × 1 sztuka';
      } else if (remaining === need) {
        $title.textContent = 'Wybierz 2 pojedyncze kolczyki';
      } else {
        $title.textContent = 'Wybierz jeszcze ' + remaining + ' × 1 sztuka';
      }
    }

    let sum = 0;
    sel.x.concat(sel.y).forEach(function (p) {
      sum += Number(p.price) || 0;
    });
    const pay = isComplete() ? CONFIG.fixedPrice : sum;
    if ($total) $total.textContent = fmtMoney(pay);

    if ($save) {
      const saveAmt = isComplete() ? Math.max(0, sum - CONFIG.fixedPrice) : 0;
      const pct = saveAmt > 0 && sum > 0 ? saveAmt / sum : 0;
      if (saveAmt > 0.01) {
        $save.innerHTML =
          'Oszczędzasz ' +
          fmtMoney(saveAmt) +
          ' <span class="save-badge-t4e">' +
          fmtPercent(pct) +
          '</span>';
        $save.classList.remove('hidden-t4e');
      } else {
        $save.classList.add('hidden-t4e');
      }
    }

    if ($cta) {
      $cta.disabled = !isComplete() || checkoutBusy;
      $cta.classList.toggle('disabled-t4e', !isComplete() || checkoutBusy);
      if (!checkoutBusy) {
        $cta.textContent = isComplete()
          ? 'Dodaj zestaw za ' + fmtMoney(CONFIG.fixedPrice)
          : 'Wybierz produkty (1 sztuka)';
      }
    }

    if ($avatars) {
      const frag = document.createDocumentFragment();
      const all = sel.x.concat(sel.y);
      for (let i = 0; i < need; i++) {
        const slot = document.createElement('div');
        const item = all[i];
        if (item && item.image) {
          slot.className = 'bsu-avatar';
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          slot.appendChild(img);
        } else {
          slot.className = 'bsu-avatar bsu-avatar--empty';
          slot.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>';
        }
        frag.appendChild(slot);
      }
      $avatars.innerHTML = '';
      $avatars.appendChild(frag);
    }

    // same-collection: nic nie ukrywamy; różne X/Y: klasyczne bramkowanie
    if (!CONFIG.sameCollection) {
      const xDone = sel.x.length >= CONFIG.limits.x;
      document.querySelectorAll('[data-bsu-card][data-b-in="x"]').forEach(function (el) {
        el.classList.toggle('hidden-by-bundle', false);
      });
      document.querySelectorAll('[data-bsu-card][data-b-in="y"]').forEach(function (el) {
        el.classList.toggle('hidden-by-bundle', !xDone);
      });
      document.querySelectorAll('[data-bsu-card][data-b-in="other"]').forEach(function (el) {
        el.classList.add('hidden-by-bundle');
      });
    } else {
      document.querySelectorAll('[data-bsu-card][data-b-in="other"]').forEach(function (el) {
        el.classList.add('hidden-by-bundle');
      });
      document.querySelectorAll('[data-bsu-card][data-b-in="x"], [data-bsu-card][data-b-in="y"]').forEach(function (el) {
        el.classList.remove('hidden-by-bundle');
      });
    }

    syncButtons();
    saveSelection();
  }

  function groupForCard(card) {
    if (CONFIG.sameCollection) {
      // najpierw uzupełniaj X, potem Y
      if (sel.x.length < CONFIG.limits.x) return 'x';
      return 'y';
    }
    return card.getAttribute('data-b-in') === 'y' ? 'y' : 'x';
  }

  function toggleFromButton(btn) {
    const card = findCard(btn);
    if (!card) return;
    const id = String(btn.dataset.variantId || '');
    const price = Number(btn.dataset.price) || 0;
    const img = card.querySelector('.bsu-media img');
    const image = img ? img.currentSrc || img.src : '';
    const title = (card.querySelector('.bsu-title') || {}).textContent || '';

    const inX = sel.x.findIndex(function (p) {
      return p.id === id;
    });
    const inY = sel.y.findIndex(function (p) {
      return p.id === id;
    });

    if (inX >= 0) {
      sel.x.splice(inX, 1);
      render();
      return;
    }
    if (inY >= 0) {
      sel.y.splice(inY, 1);
      render();
      return;
    }

    if (isComplete()) {
      pulse();
      return;
    }

    const group = groupForCard(card);
    if (sel[group].length >= CONFIG.limits[group] && !CONFIG.sameCollection) {
      pulse();
      return;
    }
    if (CONFIG.sameCollection && countSelected() >= needTotal()) {
      pulse();
      return;
    }

    // w trybie sameCollection dopychamy do wolnego bucketa
    let target = group;
    if (CONFIG.sameCollection) {
      if (sel.x.length < CONFIG.limits.x) target = 'x';
      else target = 'y';
    }

    sel[target].push({ id: id, price: price, image: image, title: title });
    render();
  }

  function pulse() {
    W.style.boxShadow = '0 0 0 4px rgba(252,211,77,.45), 0 -16px 42px rgba(2,6,23,.2)';
    setTimeout(function () {
      W.style.boxShadow = '';
    }, 240);
  }

  async function proceedToCheckout() {
    if (!isComplete()) {
      pulse();
      return;
    }
    if (checkoutBusy) return;
    checkoutBusy = true;
    if ($cta) {
      $cta.disabled = true;
      $cta.dataset.label = $cta.textContent;
      $cta.textContent = 'Przetwarzanie…';
    }

    const variantIds = sel.x.concat(sel.y).map(function (p) {
      return Number(p.id);
    });

    try {
      if (!MINT_ENDPOINT || /CHANGE-ME/.test(MINT_ENDPOINT)) {
        throw new Error('Brak skonfigurowanego MINT_ENDPOINT');
      }

      const mintRes = await fetch(MINT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bundle: CONFIG.discountCode, variantIds: variantIds }),
      });
      const mint = await mintRes.json().catch(function () {
        return {};
      });
      if (!mintRes.ok) throw new Error('mint: ' + (mint.error || mintRes.status));

      if (CONFIG.clearCartBeforeCheckout) {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
        });
      }

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: variantIds.map(function (id) {
            return {
              id: id,
              quantity: 1,
              properties: {
                _bundle: CONFIG.discountCode,
                _bundle_unit: 'single',
              },
            };
          }),
        }),
      });
      if (!addRes.ok) throw new Error('cart add failed');

      saveSelection({ x: [], y: [] });
      sel = { x: [], y: [] };

      window.location.href = mint.code
        ? '/checkout?discount=' + encodeURIComponent(mint.code)
        : '/checkout';
    } catch (e) {
      console.error('[bundle-single] checkout error', e);
      alert('Nie udało się przygotować rabatu zestawu. Spróbuj ponownie za chwilę.');
      checkoutBusy = false;
      if ($cta && $cta.dataset.label) $cta.textContent = $cta.dataset.label;
      render();
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.js-bsu-toggle');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        toggleFromButton(btn);
        return;
      }
      if (e.target.closest('#bundle-cta-single-t4e')) {
        e.preventDefault();
        proceedToCheckout();
      }
    },
    true
  );

  // blokuj przejście w kartę gdy klik w przycisk
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-bsu-toggle')) {
      e.preventDefault();
    }
  });

  render();
})();
